export const INPUT_FIELD_SIZES = [48, 40, 32]
